/** 所傳入 [states] props 的 index */
export const index = {
  localPhoneArea: 0,
  localPhone: 1,
  localPhoneExt: 2,
};
